import * as yup from "yup";
import { testFloat, testPositiveFloat } from "../../../products/utils";

export const schema = yup.object().shape({
  id: yup.string().optional(),
  supplierId: yup.string().optional(),
  supplierCode: yup.string().optional(),
  stockOrderId: yup.string().required("Stock Order Id is required"),

  productId: yup.string().optional(),
  quantity: yup
    .string()
    .test("valid-quantity", "Invalid Value", testFloat as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required("Quantity is required"),

  barcode: yup.string().when("productId", {
    is: (productId: string) => !productId,
    then: yup.string().required("Barcode is required"),
    otherwise: yup.string().optional(),
  }),
  name: yup.string().optional(),
});
